import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RetriggerGroupSyncService {

  constructor(private http: HttpClient) {}

  /**
   * Retrigger sync for specified groups
   * @param baseUrl - Base URL for API
   * @param taxYear - Tax year
   * @param groups - Comma-separated list of group names
   * @returns Observable with the response
   */
  retriggerSync(
    baseUrl: string,
    taxYear: string,
    groups: string
  ): Observable<any> {
    const url = `${baseUrl}/reTriggerGroupSync?tax_year=${taxYear}&groups=${groups}`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, null, { headers, withCredentials: true });
  }

  /**
   * Alternative method - Save retrigger group sync (if needed)
   * @param baseUrl - Base URL for API
   * @param clientKey - Client key
   * @param taxYear - Tax year
   * @param groups - Comma-separated list of group names
   * @returns Observable with the response
   */
  saveRetriggerGroupSync(
    baseUrl: string,
    clientKey: string,
    taxYear: string,
    groups: string
  ): Observable<any> {
    const url = `${baseUrl}/retriggerGroupSync?client_key=${clientKey}&tax_year=${taxYear}&groups=${groups}`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, null, { headers, withCredentials: true });
  }
}
